import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useRef,
} from "react";
import styles from "./Dropdown.module.css";

type DropdownProps = {
  children: ReactNode;
  dropdown: ReactNode;
  anchor: "left" | "right" | "center";
  position?: "bottom" | "top";
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  variant?: "regular" | "no-padding";
};

const Dropdown: React.FC<DropdownProps> = ({
  children,
  dropdown,
  anchor,
  position = "bottom",
  isOpen,
  setIsOpen,
  variant = "regular",
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen]);

  return (
    <div className={styles.dropdown} ref={dropdownRef}>
      {children}
      {isOpen && (
        <div
          className={
            styles["dropdown-content"] +
            " " +
            styles["anchor-" + anchor] +
            " " +
            styles["position-" + position] +
            " " +
            styles["variant-" + variant] +
            " fade-in"
          }
        >
          {dropdown}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
